import { render, staticRenderFns } from "./StageCrudCardFields.vue?vue&type=template&id=3dda3594"
import script from "./StageCrudCardFields.vue?vue&type=script&lang=js"
export * from "./StageCrudCardFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports